import React from 'react';
import { Flex } from '@tremor/react';
import NavigationLinks from './NavigationLinks';
import AppBrandInline from './AppBrandInline';
import './Header.css';

function Header({ activeTab, setActiveTab, onLogout, accountRestricted = false }) {
  const handleLogoClick = () => {
    if (accountRestricted) return;
    if (setActiveTab) {
      setActiveTab('discover');
    }
  };

  return (
    <header className="app-header">
      <div className="app-header-orbit" aria-hidden="true">
        <div className="app-header-orbit-inner">
          <div className="app-header-orbit-circle app-header-orbit-circle--small" />
          <div className="app-header-orbit-circle app-header-orbit-circle--medium" />
          <div className="app-header-orbit-circle app-header-orbit-circle--large" />
          <div className="app-header-orbit-circle app-header-orbit-circle--xlarge" />
          <div className="app-header-orbit-circle app-header-orbit-circle--xxlarge" />
        </div>
      </div>
      <Flex className="header-content" justifyContent="between" alignItems="center">
        {/* Lewa strona: marka (wyszukiwarka adresu jest na mapie) */}
        <div className="header-left">
          <button type="button" className="app-brand-btn" onClick={handleLogoClick} aria-label="PlanGoNOW - przejdź do odkrywania">
            <AppBrandInline />
          </button>
        </div>

        {/* Right: Navigation Menu */}
        <div className="header-right">
          <NavigationLinks
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            onLogout={onLogout}
            accountRestricted={accountRestricted}
          />
        </div>
      </Flex>
    </header>
  );
}

export default Header;
